import React from 'react';
import './Images.css';

// Array of placeholder images. Replace these URLs with your own images if needed.
const images = [
  '/images/article-cover.webp',
  '/images/Adapted-Graphic.webp',
  '/images/Adapting-graphin.webp',
  '/images/article-cover1.webp',
  '/images/cover2.webp',
  '/images/Acid-graphic.webp',
  '/images/stuffly.webp',
  '/images/stuart.webp',
  '/images/stuffly3.webp',
  '/images/3.webp',
  '/images/graphic-designs.webp',
  '/images/prod.webp',
  '/images/3d.webp',
  '/images/freelance.webp',
  '/images/article-cover1.webp',
  '/images/freelance2.webp',
  '/images/illus.webp',
  '/images/prod3.webp',
  '/images/stuffly3.webp',
];

const ImageGrid = () => {
  return (
    <div className="container my-4">
      <div className="row">
        {images.map((image, index) => (
          <div className="col-6 col-md-3 mb-4" key={index}>
            <img
              src={image}
              alt={`Image ${index + 1}`}
              className="custom-img"
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default ImageGrid;
